var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 39,
    viewBox: "0 0 64 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36408 19.5538C-0.0247548 20.4573 -0.418204 22.3156 0.485289 23.7044C1.38878 25.0932 3.24708 25.4867 4.63592 24.5832L1.36408 19.5538ZM32.3118 3L33.9725 0.501562C32.9753 -0.161228 31.6796 -0.167625 30.6759 0.485289L32.3118 3ZM59.3393 24.5669C60.7192 25.4841 62.5813 25.109 63.4984 23.7292C64.4156 22.3493 64.0405 20.4872 62.6607 19.5701L59.3393 24.5669ZM4.63592 24.5832L33.9477 5.51471L30.6759 0.485289L1.36408 19.5538L4.63592 24.5832ZM30.6512 5.49844L59.3393 24.5669L62.6607 19.5701L33.9725 0.501562L30.6512 5.49844Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36408 33.0606C-0.0247548 33.9641 -0.418204 35.8224 0.485289 37.2112C1.38878 38.6001 3.24708 38.9935 4.63592 38.09L1.36408 33.0606ZM32.3118 16.5068L33.9725 14.0084C32.9753 13.3456 31.6796 13.3392 30.6759 13.9921L32.3118 16.5068ZM59.3393 38.0738C60.7192 38.9909 62.5813 38.6158 63.4984 37.236C64.4156 35.8561 64.0405 33.9941 62.6607 33.0769L59.3393 38.0738ZM4.63592 38.09L33.9477 19.0215L30.6759 13.9921L1.36408 33.0606L4.63592 38.09ZM30.6512 19.0053L59.3393 38.0738L62.6607 33.0769L33.9725 14.0084L30.6512 19.0053Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.15d611c4.svg";
export { ForwardRef as ReactComponent };